import { useCallback, useState } from 'react'
import {
  fetchAll,
  TaskActualWorkApprovalStatusRow,
  TaskActualWorkApprovalStatusTenantResponse,
} from '../taskActualWorkApprovalStatus'
import { TaskActualWorkApprovalStatusSearchCondition } from './useSearchCondition'

export const useTaskActualWorkApprovalStatusData = () => {
  const [data, setData] = useState<TaskActualWorkApprovalStatusRow[]>([])
  const [loading, setLoading] = useState(true)

  const fetchRecords = useCallback(
    async (
      startDate: string,
      endDate: string,
      searchCondition?: TaskActualWorkApprovalStatusSearchCondition
    ) => {
      const response = await fetchAll(startDate, endDate, searchCondition)
      const json = response.json as TaskActualWorkApprovalStatusTenantResponse[]
      setLoading(true)
      setData([])
      const rows = json.map(
        (item: TaskActualWorkApprovalStatusTenantResponse) => {
          return {
            uuid: item.user.uuid,
            division: item.user.division?.displayName,
            position: item.user.position?.displayName || '',
            userName: item.user.name,
            businessPartner: item.user.partnerMember,
            companyName: item.user.businessClient?.displayName,
            userIconUrl: item.user.iconUrl || undefined,
            discrepancyActualWorkingHour:
              item.allProjects.missingActualWorkingHourFlag,
            discrepancyTaskActualWork:
              item.allProjects.missingTaskActualWorkFlag,
            requestStatus: item.allProjects.requestStatus,
            // All Projects Info
            scheduledWorkingDays: item.allProjects.scheduledWorkingDays,
            absences: item.allProjects.absences,
            workingDays: item.allProjects.workingDays,
            totalWorkingTime: item.allProjects.totalWorkingTime,
            totalActualWorkingHour: item.allProjects.totalActualWorkingHour,
            requestedHour: item.allProjects.requestedHour,
            unRequestedHour: item.allProjects.unRequestedHour,
            approvedHour: item.approvedHour,
            unApprovedHour: item.unapprovedHour,
          }
        }
      )
      setData(rows)
      setLoading(false)
    },
    []
  )

  return {
    data,
    loading,
    fetchRecords,
  }
}
